import Image from 'next/image';
import { FormattedMessage, useIntl } from 'react-intl';
import onePercentForThePlanetLogoSrc from './one-percent-logo.svg';
import styles from './OnePercentForThePlanet.module.scss';

export default function OnePercentForThePlanet() {
  const intl = useIntl();

  return (
    <section className={styles.container}>
      <a href="https://directories.onepercentfortheplanet.org/profile/alltrails-inc" target="_blank" rel="noreferrer">
        <Image alt={intl.formatMessage({ defaultMessage: '1% for the Planet' })} src={onePercentForThePlanetLogoSrc} />
      </a>
      <div className={styles.text}>
        <FormattedMessage defaultMessage="As a proud member of 1% for the Planet, we give 1% of our annual sales to nonprofit organizations focusing on protecting the wild places we cherish and creating positive change for a healthier planet." />
      </div>
    </section>
  );
}
